import { handlePaymentThatRequiresCustomerAction } from './requires-customer-action';
import { Stripe } from '@stripe/stripe-js';
import { ProcessingParams } from '../../types/stripe/processing-params';
import * as payment from '@webapp/sdk/payment';
import { CustomerMetadata } from '@services/payment/types/api/customer-metadata';

export const retryInvoiceWithNewPaymentMethod = async (
  stripe: Stripe,
  customerId: string,
  paymentMethodId: string,
  invoiceId: string,
  priceId: string,
  customer: CustomerMetadata
) => {
  const result = await payment.retry(
    customerId,
    paymentMethodId,
    invoiceId,
    customer
  );

  if (result.error) {
    // The card had an error when trying to attach it to a customer.
    throw result;
  }

  const params: ProcessingParams = {
    invoice: result,
    paymentMethodId,
    priceId,
    isRetry: true,
  };

  return handlePaymentThatRequiresCustomerAction(stripe, params);
};
